import type { FaireProductEntity } from "../../entity_types/product";

export const p_bkp31j60: FaireProductEntity = {
  token: "p_bkp31j60",
  type: "product",
  name: "It's Your Birthday Greeting Card",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/69d57feef54640cc7b7b2a5a81c8821cf7f189d8e44fd54fb627f8f38eaadda0.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/0ebbc50cc4c31e4d2510a080c0a20840ef089f2a90a252238321f050fcb2d52f.png",
    "https://cdn.faire.com/fastly/372273c8c76e4d609bd66e7ae17129709d824886cb5efc3bae1ba73b8459b738.png",
  ],
  priceDollars: 3,
  description:
    "At E. Frances, we believe connection makes the world better. And happier! Our original artwork paired with just-right words warms the heart and helps make meaningful connections easier. Every card begins with a lovingly painted watercolor, and is then printed on luxurious heavyweight paper with brilliant color and, when featured, metallic foil accents.\n\nAnd because we think tiny details can make a big impact, you’ll always find a second illustration on the back of every card!",
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:36:12.336Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
